import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AgencyDocumentSlug, IAgency } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from './api.service.abstract';

@Injectable({ providedIn: 'root' })
export class AgencyService extends ApiService<IAgency> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'user/api/user-groups/agencies');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8095';
    }
  }

  findWithSupplier(
    supplierId: number | string
  ): Observable<HttpResponse<IAgency[]>> {
    return this.http.get<IAgency[]>(`${this.url}/${this.endpoint}`, {
      params: { supplierId },
      observe: 'response',
    });
  }

  /** The agency with its registration details and documents (PUL-3224). */
  findAgency(id: string): Observable<HttpResponse<IAgency>> {
    return this.http.get<IAgency>(`${this.url}/${this.endpoint}/${id}`, {
      observe: 'response',
    });
  }

  downloadDocument(
    id: string,
    slug: AgencyDocumentSlug
  ): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.url}/${this.endpoint}/${id}/documents/${slug}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  /**
   * Emails the completion link to the agency's admins. The body is null (204)
   * when there was nothing to send: the agency is complete, or has no address.
   */
  requestCompletion(id: string): Observable<HttpResponse<IAgency | null>> {
    return this.http.post<IAgency | null>(
      `${this.url}/${this.endpoint}/${id}/completion-request`,
      null,
      { observe: 'response' }
    );
  }
}
